
import ProductCard from '~/components/product-card/ProductCard'
import Button from '~/components/buttons/Button'
import { parseProductFromShopify } from '~/helpers/shopify/product'
import ProductTester from '~/helpers/shopify/tests'
export default {
  components: { ProductCard, Button },
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      products: [],
    }
  },
  computed: {
    isDev() {
      return process.env.NODE_ENV === 'development'
    },
    widthColumnTable() {
      return `w-1/${this.products.length - 1}`
    },
  },
  async beforeMount() {
    const internalTypesColors = this.extractInternalTypesColors()
    if (internalTypesColors) {
      const productFetched = await this.fetchProductsByInternalTypes(
        internalTypesColors
      )
      if (productFetched?.length > 0) {
        this.blok.products.forEach((obj) => {
          this.products.push({
            tableWording: obj,
            product: productFetched.find(
              (p) =>
                p.internal_type.toLowerCase() ===
                obj.internal_type.toLowerCase()
            ),
          })
        })
      }
    }
  },
  methods: {
    extractInternalTypesColors() {
      return [
        ...new Set(
          this.blok.products.map((obj) => {
            return {
              internalType: obj.internal_type,
              color: obj.color.toUpperCase(),
            }
          })
        ),
      ]
    },
    async fetchProductsByInternalTypes(internalTypesColors) {
      try {
        if (internalTypesColors?.length > 0) {
          const { data } =
            await this.$shopify.product.getProductsByInternalType(
              internalTypesColors.map((obj) => obj.internalType)
            )
          if (data.products.edges.length > 0) {
            const products = []
            data.products.edges.forEach((p) => {
              const product = p.node
              const internalType = product.handle.split('-').pop()
              const productsWithMatchingType = this.blok.products.filter(
                ({ internal_type }) => {
                  return internal_type.toLowerCase() === internalType
                }
              )
              productsWithMatchingType.forEach(({ color }) => {
                const test = new ProductTester(
                  product,
                  color,
                  this.$i18n.locale
                )
                if (
                  product &&
                  test.productExist() &&
                  test.colorExist() &&
                  test.metafieldsExist() &&
                  test.metafieldsLangExist() &&
                  test.metafieldsColorExist()
                ) {
                  products.push(
                    parseProductFromShopify(product, this.$i18n.locale, color)
                      .result
                  )
                }
              })
            })
            return products
          }
        }
      } catch (e) {
        this.$sentryException(e, {
          source: 'Static - Carousel V2',
          level: 'fatal',
          extra: `Static - Carousel V2 - fetchProductsByInternalTypes() fail : ${e}`,
        })
      }
    },
  },
}
